module.exports = __webpack_public_path__ + "img/beego.2a3a9194.svg";